import { useBackend } from "../../services";

export const useGetSpreadsheetImportStatus = () => {
  const { get } = useBackend();
  return async () => {
    return await get("xlsx/import");
  };
};
